import React from 'react';
import browsers from '../../assets/images/chrome-logo.png';
import './unsupportedBrowser.scss';

const UnsupportedBrowserContainer = () => (
    <div className="flexbox-fill unsupported-container">
        <div className="message-container">
            <div className="unsupported-title">Unfortunately your browser is not supported</div>
            <div className="unsupported-message">
                Please use Google Chrome to get the best Musico experience <br />
                <a target="blank" href="https://www.google.com/chrome/browser/desktop/">Chrome</a>&nbsp;
            </div>
            <img className="unsupported-img" height="100px" src={browsers} alt="" />
        </div>
    </div>
);

export default UnsupportedBrowserContainer;
